import { useEffect, useRef } from 'react'

function useDebouncedRender(callback: () => void, delay: number) {
  const timerRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    // Clear previous timer on each render
    if (timerRef.current) {
      clearTimeout(timerRef.current)
    }

    // Set new timer
    timerRef.current = setTimeout(() => {
      callback()
    }, delay)

    // Cleanup on unmount
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current)
      }
    }
  }) // No dependency array = runs after every render
}

export default useDebouncedRender